import {call, put} from "typed-redux-saga";
import {Api} from "modules/utils";
import {fetchOverallRanking, fetchOverallRankingSuccess, setCurrentPage} from "modules/actions";
import {SagaIterator} from "redux-saga";

export const fetchOverallRankingSaga = function* (
	action: ReturnType<typeof fetchOverallRanking>
): SagaIterator {
	try {
		const {payload} = action;
		const result = yield* call(Api.Ranking.getOverallRanking, payload);

		yield* put(fetchOverallRankingSuccess(result.success));

		if (result.success.next) {
			const {offset: page} = payload;
			const nextPage = page ? page + 1 : 1;

			yield* put(setCurrentPage(nextPage));

			yield* call(fetchOverallRankingSaga, {
				...action,
				payload: {
					...payload,
					offset: nextPage,
				},
			});
		}
	} catch (err) {
		console.log(err);
	}
};
